export default __webpack_public_path__ + "static/cdc-logo-372f7ccb182fb3501ad7cbf35b9c6d23.svg";